"use client";
import { messaging } from "@/firebase/firebase-init";
import { useFcmToken } from "@/hooks/use-fcm-token";
import { onMessage } from "firebase/messaging";
import { useRouter } from "next/navigation";
import React, { useEffect, useRef } from "react";
import { toast } from "sonner";

const PushNotification = () => {
  const notificationSound = useRef<HTMLAudioElement | null>(null);
  const { refresh } = useRouter();

  useFcmToken();

  useEffect(() => {
    notificationSound.current = new Audio("/sounds/notification-sound.wav");

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("payload", payload);

      // 🔊 play sound
      notificationSound.current?.play().catch(() => {
        // autoplay may be blocked until user interacts
        console.warn("Sound autoplay blocked");
      });

      toast(payload.notification?.title, {
        description: payload.notification?.body,
        duration: 5000,
        position: "top-right",
      });

      refresh();
    });

    return () => {
      unsubscribe();
    };
  }, [refresh]);

  return <></>;
};

export default PushNotification;
